import { JsonData } from 'types';

type CancellationDetails = {
  date: string;
  user: string;
  reason: string;
  comment: string;
};

enum CancelationAttribute {
  ReasonId = 'cancellation_reasonID',
  Comment = 'cancellation_otherreason',
  UserId = 'cancelled_user_ID',
  Date = 'cancelled_datetime',
}

export const useServiceCancellationDetails = (attributes?: JsonData) => {
  const isAttributesExist = Object.values(CancelationAttribute).every((key) =>
    new Set(attributes?.map((item) => item.key)).has(key),
  );

  if (!isAttributesExist) return { cancellationDetails: null };

  const getAttributeValue = (name: CancelationAttribute) => attributes?.find((item) => item.key === name)?.value;

  const cancellationDetails: CancellationDetails = {
    date: getAttributeValue(CancelationAttribute.Date),
    user: getAttributeValue(CancelationAttribute.UserId),
    comment: getAttributeValue(CancelationAttribute.Comment),
    reason: getAttributeValue(CancelationAttribute.ReasonId),
  };

  return { cancellationDetails };
};
